import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";

import { Lightbox } from "components/Lightbox";
import { Loading } from "components/Loading";

// Jediný zdroj otázky — jde do `ariaLabel` i do viditelného nadpisu, ať se ty dva
// texty nemůžou rozejít. [TD-344]
const QUESTION = "Chceš úlohu vrátit do tréninku?";

interface Props {
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

// AIDEV-NOTE: `ariaLabel`, ne `bodyTitleId` — stejný důvod jako u BlacklistInConfirmModal:
// za `isLoading` zmizí ze stromu i nadpis, na který by `aria-labelledby` mířilo. [TD-344]
export const BlacklistOutConfirmModal: React.FC<Props> = ({ isLoading, onClose, onConfirm }) => (
  <Lightbox show onHide={onClose} ariaLabel={QUESTION}>
    {isLoading ? (
      <Loading />
    ) : (
      <>
        <div className="mb-8px text-center">
          <Image src="/images/120-blacklist-out.svg" />
        </div>
        {/* fs-18 drží dosavadní vzhled h3 — nadpisy se sjednocují na sémantické h2. [TD-344] */}
        <h2 className="text-center mb-20px px-5 fs-18">{QUESTION}</h2>
        <Button variant="outline-primary" className="w-100" onClick={onConfirm}>
          Ano, vrátit do tréninku
        </Button>
        <Button variant="link" className="w-100" onClick={onClose}>
          Ne, ponechat jako vyřazenou
        </Button>
      </>
    )}
  </Lightbox>
);
